import { render } from "./Buttons.vue?vue&type=template&id=73dbb81d"
import script from "./Buttons.vue?vue&type=script&lang=js"
export * from "./Buttons.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__